import { render, staticRenderFns } from "./VendingMachineScreen.vue?vue&type=template&id=1bbbfc3e"
import script from "./VendingMachineScreen.vue?vue&type=script&lang=js"
export * from "./VendingMachineScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports